import { observer } from 'mobx-react';
import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import Header from '../../components/header';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--gray-02);
`;

const Content = styled.div`
  max-width: var(--content-width);
  width: 100%;
  margin: 40px auto;
`;

export const ApplicationLayout: React.FC = observer(() => {
  return (
    <Container>
      <Header />
      <Content>
        <Outlet />
      </Content>
    </Container>
  );
});
